import { faPlus, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { KavelDetail } from "./KavelDetail";
import { ReportDrawer } from "./ReportDrawer";
import { BULK_LIMIT, useWorkspaceSearch } from "./search";
import { WorkspaceMap } from "./WorkspaceMap";

const Header = ({ project }: { project: any }) => {
  const { active, label, total, error, summary, adding, addAll, clear } = useWorkspaceSearch();
  const parcels = project.parcels || [];
  const area = parcels.reduce((sum: number, p: any) => (p.area || 0) + sum, 0);

  if (active) {
    const fits = total !== undefined && total > 0 && total <= BULK_LIMIT;
    return (
      <div className="flex items-start gap-2 border-b bg-white px-4 py-2">
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-bold">{label || "Filter"}</p>
          <p className={`text-xs ${error ? "text-red-600" : "text-gray-600"}`}>
            {error ??
              summary ??
              (total === undefined
                ? "Zoeken…"
                : `${total.toLocaleString("nl-NL")} ${total === 1 ? "kavel" : "kavels"}`)}
          </p>
        </div>

        {/* Alles toevoegen kan alleen bij een handzame selectie: elk kavel kost
            een reference-call. Boven de grens geen knop maar uitleg. */}
        {fits ? (
          <button
            onClick={() => addAll(project.id)}
            disabled={adding}
            className="shrink-0 rounded-md bg-bright-yellow px-3 py-1.5 text-xs font-bold hover:bg-yellow disabled:opacity-50"
          >
            <FontAwesomeIcon icon={faPlus} className="pr-1" />
            {adding ? "Bezig…" : `Alle ${total} toevoegen`}
          </button>
        ) : (
          total !== undefined &&
          total > BULK_LIMIT && (
            <span className="max-w-40 shrink-0 text-right text-[11px] text-gray-400">
              Te veel om in één keer toe te voegen — verfijn het filter
            </span>
          )
        )}

        <button
          onClick={clear}
          className="shrink-0 text-gray-400 hover:text-black"
          title="Filter wissen"
          aria-label="Filter wissen"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>
    );
  }

  return (
    <div className="border-b bg-white px-4 py-2">
      <p className="truncate text-sm font-bold">{project.name}</p>
      <p className="text-xs text-gray-600">
        {parcels.length === 0
          ? "Nog geen percelen — vraag de assistent naar kavels die bij je zoekvraag passen"
          : `${parcels.length} ${parcels.length === 1 ? "perceel" : "percelen"}${
              area > 0 ? ` · ${Math.round(area).toLocaleString("nl-NL")} m²` : ""
            }`}
      </p>
    </div>
  );
};

export const DetailPanel = ({ project }: { project: any }) => (
  <div className="flex h-full flex-col">
    <Header project={project} />
    <div className="relative min-h-0 flex-1">
      <WorkspaceMap parcels={project.parcels || []} />
      <KavelDetail project={project} />
      <ReportDrawer />
    </div>
  </div>
);
